module.exports = __webpack_public_path__ + "static/media/banner.019e1026.png";